import { render } from "./CadernoFormando.vue?vue&type=template&id=bdd29384&scoped=true"
import script from "./CadernoFormando.vue?vue&type=script&lang=js"
export * from "./CadernoFormando.vue?vue&type=script&lang=js"

import "./CadernoFormando.vue?vue&type=style&index=0&id=bdd29384&scoped=true&lang=css"
import "./CadernoFormando.vue?vue&type=style&index=1&id=bdd29384&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdd29384"]])

export default __exports__